/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { ModalSection, ModalContainer, ModalHeader, ModalHeaderTitle, ModalBody, ModalHeaderSubtitle } from './styles';

export default ({
  title,
  dataCy,
  subtitle,
  children,
  warningTitle,
  margin = '20vh auto 200px auto',
  padding = '35px 0 35px 50px',
  width,
  minWidth,
  maxWidth,
  active,
 responsive = false,
}: {
  children: React.ReactNode;
  title?: string;
  margin?: string;
  dataCy?: string;
  subtitle?: string;
  warningTitle?: boolean;
  padding?: string;
  width?: string;
  minWidth?: string;
  maxWidth?: string;
  active?: any;
  color?: string;
  responsive?: boolean;
  
}) => {

  useEffect(() => {
    function closeModal(event) {
      if (active) {
        var modal = document.getElementById("modal");
        if (event.target === modal && active !== null) {
          active(false);
        }
      }
    }
    window.addEventListener('click', closeModal);
    return () => window.removeEventListener('click', closeModal);
  }, [])

  return (
    <ModalSection id="modal">
      <ModalContainer margin={margin} data-cy={dataCy} >
        {title && <ModalHeader padding={padding}>
          <ModalHeaderTitle warningTitle={warningTitle}>{title}</ModalHeaderTitle>
          <ModalHeaderSubtitle>{subtitle}</ModalHeaderSubtitle>
        </ModalHeader>}
        <ModalBody
          width={width}
          minWidth={minWidth}
          maxWidth={maxWidth}
          padding={padding}
          responsive={responsive}
          >
          {children}
        </ModalBody>
      </ModalContainer>
    </ModalSection>)
};
